module.exports = __webpack_public_path__ + "static/bank-russia-d2493dcdbb65cef3350f7cb214adea5f.svg";